var exports = {
  "k": "container__id4LMT",
};

module.exports = exports;
